import { constants } from 'redux/constants/redux-constants'

export const setConsent = payload => ({
	type: constants.CONSENT.SET_CONSENT,
	payload: payload,
})
